import { Component, Directive, Input, EventEmitter, Output } from '@angular/core';
import { ModalService } from '@edassist/shared';
import { FormComponent, FORM_CONSTANTS } from '../forms';
import { BUTTON_TYPES } from '../button/button-types.enum';

@Component({
	selector: 'ea-ui-modal-form',
	templateUrl: './modal-form.component.html',
	styleUrls: ['../forms/form/form.component.scss', './modal-form.component.scss']
})
export class ModalFormComponent extends FormComponent {
	@Input() forModalId: string;
	@Input() isShowSubmit = true;
	@Input() isShowCancel = true;
	@Input() submitButtonType = BUTTON_TYPES.Primary;
	@Input() cancelButtonType = BUTTON_TYPES.Secondary;
	@Input() isSubmitting = false;
	@Input() submitLabel = FORM_CONSTANTS.buttonSaveText;
	@Input() cancelLabel = FORM_CONSTANTS.buttonCancelText;
	@Input() enableSubmitButton = false;
	@Output() readonly cancelModalEvent = new EventEmitter<boolean>();

	constructor(private readonly modalService: ModalService) {
		super([], []);
	}

	handleModalFormCancel(): void {
		this.modalService.closeModal(this.forModalId);
		this.cancelModalEvent.emit(true);
	}
}
@Directive({
	//eslint-disable-next-line @angular-eslint/directive-selector
	selector: 'form-footer-content'
})
export class FormFooterContentDirective {}
